import React, { PureComponent } from 'react';
import SectionTitle from '@client/components/texts/SectionTitle';
import { strings } from '@client/localization/Localization';
import Jennie from '@client/shared/styles/assets/images/jennie.jpg';
import Jan from '@client/shared/styles/assets/images/jan.jpg';
import Arvid from '@client/shared/styles/assets/images/arvid.jpg';
import shapes from '@client/shared/js/shapes';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './theTeamSection.scss';

const TheTeam = () => {
  return (
    <div className={styles.theTeam}>
      <div className={styles.theTeamLeadText}>{strings.theTeamLeadText}</div>
      <div className={styles.teamMembersContainer}>
        <div className={styles.teamMemberContainer}>
          <img src={Jan} alt="Jan Axelsson" />
          <div className={styles.teamMemberName}>{strings.ceoPerson}</div>
          <div className={styles.teamMemberTitle}>{strings.ceo}</div>
          <div className={styles.teamMemberContactInfo}>{strings.ceoMail}</div>
          <div className={styles.teamMemberContactInfo}>
            {strings.ceoMobile}
          </div>
        </div>
        <div className={styles.teamMemberContainer}>
          <img src={Jennie} alt="Jennie Tinderfjäll" />
          <div className={styles.teamMemberName}>
            {strings.headOfOperationsPerson}
          </div>
          <div className={styles.teamMemberTitle}>
            {strings.headOfOperations}
          </div>
          <div className={styles.teamMemberContactInfo}>
            {strings.headOfOperationsMail}
          </div>
        </div>
        <div className={styles.teamMemberContainer}>
          <img src={Arvid} alt="Arvid Sundqvist" />
          <div className={styles.teamMemberName}>
            {strings.headOfProductionPerson}
          </div>
          <div className={styles.teamMemberTitle}>
            {strings.headOfProduction}
          </div>
          <div className={styles.teamMemberContactInfo}>
            {strings.headOfProductionMail}
          </div>
        </div>
      </div>
    </div>
  );
};

const TheBoard = () => {
  return (
    <div>
      <div className={styles.theBoard}>
        <div className={styles.boardColumn}>
          <SectionTitle
            title={strings.advisoryBoard}
            classNameTitle={themeStyles.headerMedium}
            linkTextNotActive={true}
          />
          <div className={styles.boardMember}>
            <div className={styles.boardMemberName}>
              {strings.mediaStrategistPerson}
            </div>
            <div className={styles.boardMemberTitle}>
              {strings.mediaStrategist}
            </div>
          </div>
          <div className={styles.boardMember}>
            <div className={styles.boardMemberName}>
              {strings.bureauCommunicationPerson}
            </div>
            <div className={styles.boardMemberTitle}>
              {strings.bureauCommunication}
            </div>
          </div>
          <div className={styles.boardMember}>
            <div className={styles.boardMemberName}>
              {strings.legalAdvicePerson}
            </div>
            <div className={styles.boardMemberTitle}>{strings.legalAdvice}</div>
          </div>
        </div>
        <div className={styles.boardColumn}>
          <SectionTitle
            title={strings.editorialBoard}
            classNameTitle={themeStyles.headerMedium}
            linkTextNotActive={true}
          />
          <div className={styles.boardMember}>
            <div className={styles.boardMemberName}>
              {strings.professorPerson}
            </div>
            <div className={styles.boardMemberTitle}>{strings.professor}</div>
          </div>
          <div className={styles.boardMember}>
            <div className={styles.boardMemberName}>
              {strings.headOfPopularSciencePerson}
            </div>
            <div className={styles.boardMemberTitle}>
              {strings.headOfPopularScience}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class TheTeamSection extends PureComponent {
  render() {
    return (
      <div className={styles.theTeamSection}>
        <div className={styles.theTeamSectionContentContainer}>
          <SectionTitle title={strings.theTeam} linkTextNotActive={true} />
          <TheTeam />
          <TheBoard />
        </div>
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet={shapes.graphic_about_mobile}
          />
          <img
            className={styles.shapeBottomRight}
            src={shapes.graphic_about}
            alt="Factuals graphic header mobile"
          />
        </picture>
      </div>
    );
  }
}

export default TheTeamSection;
